export default __webpack_public_path__ + "static/media/Head_1_Ear_1_C5.9046ca0d.svg";